import { createContext, useContext } from "solid-js";
import type { HabitRow } from "@habits/shared";

interface AppLayoutContextValue {
  /** Opens the habit-creation dialog. */
  openNewHabitDialog: () => void;
  /** Opens the edit dialog for an existing habit. */
  openEditHabitDialog: (habit: HabitRow) => void;
}

export const AppLayoutContext = createContext<AppLayoutContextValue>();

export const useAppLayoutContext = () => {
  const context = useContext(AppLayoutContext);
  if (!context) {
    throw new Error("useAppLayoutContext must be used within an AppLayout");
  }
  return context;
};
